
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CRUDResolverInterface, CRUDServerSideResponse } from './types/crud.types';

export interface CRUDResolverResponse<T> {
    crud: T[] | CRUDServerSideResponse<T>;
}

export abstract class CRUDResolver<T, Z extends CRUDResolverResponse<T>> implements CRUDResolverInterface<T>, Resolve<Z> {
    


    /**
     * Gestisce il ritorno dei parametri per la chiamata getData
     */
    abstract getParams(route: ActivatedRouteSnapshot);

    // abstract resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Z | Promise<Z> | Observable<Z> ;
    abstract resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any

    /**
     * Ritorna i dati per la tabella
     */
    abstract getData(params?: { [key: string]: any; }, query?: { offset: number; limit: number; }): Observable<T[] | CRUDServerSideResponse<T>>;


}